"use strict";
exports.__esModule = true;
require("rxjs/add/operator/catch");
require("rxjs/add/operator/map");
var http_1 = require("@angular/common/http");
var constants_1 = require("../shared/constants");
var utils_1 = require("../shared/utils");
var ClaimAccountService = /** @class */ (function () {
    function ClaimAccountService(http) {
        this.http = http;
    }
    // call API passing new password along with confirm password to request to send reset it
    ClaimAccountService.prototype.post = function (credentials) {
        var endpoint = utils_1.Utils.getApiUrl() + constants_1.Constants.LOGIN_SERVICES_API + constants_1.Constants.API_VERSION +
            constants_1.Constants.ACCOUNT_DOMAIN + constants_1.Constants.CLAIM_ACCOUNT_URI;
        return this.http
            .post(endpoint, credentials).map(function (response) { return response; });
    };
    return ClaimAccountService;
}());
exports.ClaimAccountService = ClaimAccountService;
